import { z } from "zod";

export enum CommunityType {
  basic = "basic",
  class = "class",
  parish = "parish",
  network = "network",
  small_group = "small_group",
  school = "school",
  religious_ed_program = "religious_ed_program",
  religious_ed_class = "religious_ed_class",
}

export const communityTypeEnum = z.enum(CommunityType);
